import React, { useMemo, useRef, useState, useEffect } from "react";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { useNavigate } from "react-router-dom";
import { getinspectionbyuniqueid, addnewfacilitytotemplate, addupdateinspectioncompliance, finaliseinspection, assignedTo, SearchContacts, geteditinspectiontemplate, submittemplatedetails, FilePath, updateinspection, updateoverviewinspection, getaddedittemplatedetails, submitupdatedtemplatedetails, updateinspectionstatus, reportacceptedbytenant, removetemplatefacilityfrominspection, getaddupdatedacilitiestotemplate, removetemplatefrominspection ,generateentryexitinspectionreport,generateroutineinspectionreport,emailroutinereporttoowner} from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner, uploadToS3WithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { dynamicUrl, addParametersForProfiles } from "../../../Utilities/profileManagement";
import "../../../components/Dashboard/Agency/PropertiesAgecny/viewPropertyDetails.css";
import moment from 'moment';
import Collapse from "../../input-components/collapse";
import TextBox from "../../input-components/textbox";
import SubNav from "../../../components/CommonSection/Header/subHeader";
import { currentProfile } from "../../../components/CommonSection/Cookie/Session";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Radio } from "antd";
import { TimePicker, Select, Button,DatePicker } from "antd";
import { Dropdown } from "primereact/dropdown";
import SelectInput from "../../input-components/selectBoxNew";
import debounce from "lodash/debounce";
import FileUpload from "../../input-components/documentUpload";
import CustomModal from "../../input-components/Modal";
import TextArea from "../../input-components/textarea";
import { MdDeleteOutline } from "react-icons/md";
import { BiEdit } from "react-icons/bi";
import { CameraOutlined,CheckCircleTwoTone,DeleteOutlined } from '@ant-design/icons';
import ImageGalleryModal from "../../input-components/imageGallary";
import { useFormik } from "formik";
import { inspectionOverSchema } from "../../../components/CommonSection/Schema/schema";
import { Dropdown as AntDropdown, Menu } from "antd";             // ✅ Ant Design Dropdown
import { DownOutlined,FilePdfOutlined } from "@ant-design/icons";
import CustomActivity from "../../input-components/customActivity"


const ViewInspection = () => {
    const [userId, setUserId] = useState("");
    const [getDetails, setGetDetails] = useState({});
    const [overviewImages, setOverviewImages] = useState([]);
    const [getDetailsTemplate, setGetDetailsTemplate] = useState({});
    const [activeTab, setActiveTab] = useState("Overview");
    const [purpose, setPurpose] = useState(1);
    const [openPanels, setOpenPanels] = useState({});
    const [dpdata, setDpdata] = useState([]);
    const [propertyManager, setPropertymanager] = useState("");
    const [facilityList, setFacilityList] = useState([]);
    const [comments, setComments] = useState("");
    const [shareWithOwner, setShareWithOwner] = useState(false);
    const [shareWithTenant, setShareWithTenant] = useState(false);
    const [labelData, setLabelData] = useState([]);
    const [tenantFolioId, setTenantFolioId] = useState(null);
    const [summary, setSummary] = useState("");
    const [openTenantModal, setOpenTenantModal] = useState(false);
    const [modalFacilityData, setModalFacilityData] = useState({ templateIndex: null, facilityIndex: null });
    const [tenantModalComment, setTenantModalComment] = useState("");
    const [tenantModalImages, setTenantModalImages] = useState([]);
    const [openAgentImageModal, setOpenAgentImageModal] = useState(false);
    const [agentImageModalData, setAgentImageModalData] = useState({ templateIndex: null, facilityIndex: null });
    const [openOverviewImageModal, setOpenOverviewImageModal] = useState(false);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [inspectionSections, setInspectionSections] = useState([]);
    const [tenantOption, setTenantOption] = useState([]);
    const [templateOptions, setTemplateOptions] = useState([]);

    const [formData, setFormData] = useState({
        RentReview: "",
        WaterMeterReading: "",
        GeneralNotes: "",
        FollowupActions: ""
    });
    const [switchValues, setSwitchValues] = useState({
        PremisesStrctlySound: false,
        LightingInRoom: false,
        Ventilation: false,
        ElctrcityOutletsSockt: false,
        PlumbingandDrainage: false,
        SuppliedElectricty: false,
        SuppliedGas: false,
        ConnectdToWaterSupply: false,
        ContainBathrm: false,
        TenantAgreesUtilities: false,
        AdditionalUtilitiesTerms: '',
        SignsMuds: false,
        PestsVermin: false,
        Rubbish: false,
        ListedLooseFill: false,
        SmokeAlarmInstalled: false,
        SmokeAlarmWorking: false,
        SmokeAlaramLastChecked: '',
        SmokeAlarmBttryReplaced: false,
        BattryChangedDate: '',
        HaveRemovableBattry: false,
        RemovableBattryChangedDate: '',
        VisibleSIgnDamage: false,
        VisibleElectricityHazard: false,
        VisibleGasHazard: false,
        TenantAgreeSafetyIssues: false,
        AdditionalTermSafetyIssues: '',
        TelephoneConnectd: false,
        InternetConnected: false,
        SeperatedMetered: false,
        ShowerheadMaximumFlow: false,
        DualFlushToilet: false,
        ColdWatrTapsMaximumFlow: false,
        CheckedWaterLeakage: false,
        WaterEfficiencyDateChecked: '',
        WatermeterReadingStart: '',
        DateofWaterMeterReadingStart: '',
        WatermeterReadingEnd: '',
        DateOdWaterMeterReadingEnd: '',
        AdditionalComments: '',
        LastDatePaintingExternal: '',
        LastDatePaintingInternal: '',
        LastDateInstalledSmokeAlarms: '',
        LastDateFloorCleaned: '',
        LandlordAgreeToUndrtakeWork: '',
        LandLordWorkDoneBy: false,
        TenantReceivedOn: '',
        LandLordWorkDoneNote: ''
    });
    const [disagreeIndexes, setDisagreeIndexes] = useState({});
    const [templates, setTemplates] = useState([
        { TemplateId: 0, Attribute: "", AttributeLabel: "" },
    ]);
    const [openAddTemplate, setOpenAddTemplate] = useState(false);
    const [openAddFacilities, setOpenAddFacilities] = useState(false);

    const fetchRef = useRef(0);
    const inputRefs = useRef([]);
    const inputRef = useRef();
    const ToastRef = useRef();
    const navigate = useNavigate();
    const currentProfiles = currentProfile.get();
    var url = new URL(window.location.href);
    var InspectionUniqueId = url.searchParams.get("InspectionUniqueId");
    const InspectionType = url.searchParams.get("inspectionType");
    const uid = url.searchParams.get("uid");
    const utype = url.searchParams.get("utype");
    const address = url.searchParams.get("address");
    const [landlordWorks, setLandlordWorks] = useState([
        { note: '', date: '' }
    ]);
    const [facilities, setFacilities] = useState([{ id: 1, name: "" }]);
    const [newTemplate, setNewTemplate] = useState({
        Attribute: "",
        AttributeLabel: ""
    });
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [tabTemplateId, setTabTemplateId] = useState(null);
    const [isTenantAccepted, setIsTenantAccepted] = useState(false)

const [currentSectionLabel, setCurrentSectionLabel] = useState("Overview", "Compliance/Utilities");
const [previousDisagreeState, setPreviousDisagreeState] = useState(null); // stores { templateIndex, facilityIndex }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        // Automatically open all compliance/utility panels when Compliance is selected
        if (purpose === 2) {
            const keys = (collapsibleMap[2] || []).map(section => section.key);
            const allOpen = keys.reduce((acc, key) => ({ ...acc, [key]: true }), {});
            setOpenPanels(allOpen);
        }
    }, [purpose]);

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    reportData(parsedData.agencyUniqueID)
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        PostApiWithSpinner(InspectionUniqueId);
        if (utype === "13") {
            setActiveTab("Report");
        }
    }, []);
    

    useEffect(() => {
        if (InspectionType === "Entry" || InspectionType === "Exit") {
            setInspectionSections(prev => [...prev,  { label: "Overview", value: 1 },{ label: "Compliance/Utilities", value: 2 }]);
        }
    }, [InspectionType]);


    const reportData = (agencyUID) => {
        const baseUrl = assignedTo + `?agencyUID=${agencyUID}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get", null, null, false)
            .then((response) => {
                if (response.object) setDpdata(response.object);
            })
    };


    const PostApiWithSpinner = (InspectionUniqueId) => {
        const baseUrl = getinspectionbyuniqueid + `?InspectionUniqueId=${InspectionUniqueId}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get", null, null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    const data = response.object;
                    setGetDetails(response.object)
                    setIsTenantAccepted(utype && !response.object.isTenantAccepted ? true : false)
                    viewinspectionmasterdata(response.object.inspectionId)
                    setFormData({
                        RentReview: data.rentReview,
                        WaterMeterReading: data.waterMeterReading,
                        GeneralNotes: data.generalNotes,
                        FollowupActions: data.followupActions
                    });
                    setSummary(getDetails.summary)
                    setShareWithOwner(data.shareWithOwner);
                    setShareWithTenant(data.shareWithTenant);
                    setPropertymanager(data?.assignedAgent?.toString())
                    const formattedOptions = [
                        { label: "(No Tenant)", value: "" },
                        {
                            label: `${data.tenantDetails.tenantName}`,
                            value: data.tenantDetails.tenantFolioId
                        }
                    ];

                    setTenantOption(formattedOptions);
                    if (data.tenantFolioId) {
                        setTenantFolioId(data.tenantFolioId || null);
                    } else {
                        setTenantFolioId("");

                    }
                }
            })
    };

    const handleInput = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const formatDateTime = (date) => {
        if (!date) return null;

        const parsed = moment(date, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601], true);
        return parsed.isValid() ? parsed.format("YYYY-MM-DDT00:00:00") : null;
    };


    const SubmitGenerateReportEntery = (onSuccess, autoSubmit) => {
        const data = {
            InspectionId: getDetails.inspectionId,
            PremisesStrctlySound: switchValues.PremisesStrctlySound,
            LightingInRoom: switchValues.LightingInRoom,
            Ventilation: switchValues.Ventilation,
            ElctrcityOutletsSockt: switchValues.ElctrcityOutletsSockt,
            PlumbingandDrainage: switchValues.PlumbingandDrainage,
            SuppliedElectricty: switchValues.SuppliedElectricty,
            SuppliedGas: switchValues.SuppliedGas,
            ConnectdToWaterSupply: switchValues.ConnectdToWaterSupply,
            ContainBathrm: switchValues.ContainBathrm,
            TenantAgreesUtilities: switchValues.TenantAgreesUtilities,
            AdditionalUtilitiesTerms: switchValues.AdditionalUtilitiesTerms,

            SignsMuds: switchValues.SignsMuds,
            PestsVermin: switchValues.PestsVermin,
            Rubbish: switchValues.Rubbish,
            ListedLooseFill: switchValues.ListedLooseFill,

            SmokeAlarmInstalled: switchValues.SmokeAlarmInstalled,
            SmokeAlarmWorking: switchValues.SmokeAlarmWorking,
            SmokeAlaramLastChecked: formatDateTime(switchValues.SmokeAlaramLastChecked),
            SmokeAlarmBttryReplaced: switchValues.SmokeAlarmBttryReplaced,
            BattryChangedDate: formatDateTime(switchValues.BattryChangedDate),
            HaveRemovableBattry: switchValues.HaveRemovableBattry,
            RemovableBattryChangedDate: formatDateTime(switchValues.RemovableBattryChangedDate),

            VisibleSIgnDamage: switchValues.VisibleSIgnDamage,
            VisibleElectricityHazard: switchValues.VisibleElectricityHazard,
            VisibleGasHazard: switchValues.VisibleGasHazard,
            TenantAgreeSafetyIssues: switchValues.TenantAgreeSafetyIssues,
            AdditionalTermSafetyIssues: switchValues.AdditionalTermSafetyIssues,

            TelephoneConnectd: switchValues.TelephoneConnectd,
            InternetConnected: switchValues.InternetConnected,

            SeperatedMetered: switchValues.SeperatedMetered,
            ShowerheadMaximumFlow: switchValues.ShowerheadMaximumFlow,
            DualFlushToilet: switchValues.DualFlushToilet,
            ColdWatrTapsMaximumFlow: switchValues.ColdWatrTapsMaximumFlow,
            CheckedWaterLeakage: switchValues.CheckedWaterLeakage,

            WaterEfficiencyDateChecked: formatDateTime(switchValues.WaterEfficiencyDateChecked),
            WatermeterReadingStart: formatDateTime(switchValues.WatermeterReadingStart),
            DateofWaterMeterReadingStart: formatDateTime(switchValues.DateofWaterMeterReadingStart),
            WatermeterReadingEnd: formatDateTime(switchValues.WatermeterReadingEnd),
            DateOdWaterMeterReadingEnd: formatDateTime(switchValues.DateOdWaterMeterReadingEnd),

            AdditionalComments: switchValues.AdditionalComments,

            LastDatePaintingExternal: formatDateTime(switchValues.LastDatePaintingExternal),
            LastDatePaintingInternal: formatDateTime(switchValues.LastDatePaintingInternal),
            LastDateInstalledSmokeAlarms: formatDateTime(switchValues.LastDateInstalledSmokeAlarms),
            LastDateFloorCleaned: formatDateTime(switchValues.LastDateFloorCleaned),

            LandlordAgreeToUndrtakeWork: switchValues.LandlordAgreeToUndrtakeWork,
            LandLordWorkDoneBy: landlordWorks.map(w => w.date),
            LandLordWorkDoneNote: landlordWorks.map(w => w.note),
            TenantReceivedOn: switchValues.TenantReceivedOn,
        };

        if (autoSubmit) {
            data.IsAutoSubmitted = true;
        }
        const baseUrl = addupdateinspectioncompliance;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data, null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    //ToastRef.current.notify(["success", response.message]);
                       const container = document.querySelector(".material-work-desk-new");
                    if (container) {
                        container.scrollTo({ top: 0, behavior: "smooth" });
                    }
                    if (typeof onSuccess === "function") {
                        onSuccess(); // 🔁 Call the next action (e.g., tab switch)
                    } else {
                        // Default flow to next section
                        const firstDynamicSection = inspectionSections.find(s => s.value >= 3);
                        if (firstDynamicSection) {
                            setPurpose(firstDynamicSection.value);
                            setTabTemplateId(firstDynamicSection.templateId);
                        }
                    }
                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            });
    };

    const SubmitFinalise = (userType) => {
        if (tenantFolioId === "") {
            ToastRef.current.notify(["error", "Tenant is Required."]);
        } else {
        const baseUrl = finaliseinspection;
        let formData = {
            InspectionUniqueId: InspectionUniqueId,
            UserType: userType === "assign" ? currentProfiles : 13,
            LoggedUserId: userId ? userId : uid
        }
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formData, null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    debugger
                    ToastRef.current.notify(["success", response.message]);
                    PostApiWithSpinner(InspectionUniqueId);
                    if(userType === "return"){
                         window.close();
                    }
                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })
        }
    };


    const tabs = utype === "13"
        ? ["Report"] // only show "Edit Report" as "Report"
        : ["Overview", "Edit Report", "Activity"];

    const handleTabs = (tabs) => {
        setActiveTab(tabs);
        if (tabs === "Edit Report" || tabs === "Report") {
            viewinspectionmasterdata(getDetails.inspectionId);
        }
        if(tabs === "Edit Report"){
            handleSubmitMainOverView()
        }
        setCurrentSectionLabel(tabs)
    }

    const handleStatClick = (selectedPurpose, id) => {
        setTabTemplateId(id);
        const switchTab = () => {
            setPurpose(selectedPurpose);

            // Reset only for dynamic sections (value >= 3)
            if (selectedPurpose >= 3) {
                setComments("");
                setOverviewImages([]);
            }
        };

        // Auto-save based on current tab
        if (purpose === 1) {
            handleSubmitOverView(switchTab, true);
        } else if (purpose === 2) {
            SubmitGenerateReportEntery(switchTab, true);
        } else {
            handleFinalSubmit("submit", switchTab, true,id);
        }
    };


    const collapsibleMap = {
        2: [ // Compliance/Utilities
            { key: "propertyInfo", label: "Property Information", questions: [] },

            {
                key: "healthIssues",
                label: "Health Issues",
                questions: [
                    { key: "SignsMuds", label: "Signs of mould and dampness" },
                    { key: "PestsVermin", label: "Pests and vermin" },
                    { key: "Rubbish", label: "Rubbish been left on the premises" },
                    { key: "ListedLooseFill", label: "Premises listed on the Loose-Fill Asbestos Insulation Register" },
                ],
            },
            {
                key: "minimumStandards", label: "Minimum Standards", questions: [
                    { key: "PremisesStrctlySound", label: "Are the premises structurally sound?" },
                    { key: "LightingInRoom", label: "Natural or artificial lighting in each room (excluding storage rooms or garages)?" },
                    { key: "Ventilation", label: "Ventilation?" },
                    { key: "ElctrcityOutletsSockt", label: "Electricity or gas outlet sockets for lighting and heating, and for appliances?" },
                    { key: "PlumbingandDrainage", label: "Plumbing and drainage?" },
                    { key: "SuppliedElectricty", label: "Supplied with electricity?" },
                    { key: "SuppliedGas", label: "Supplied with gas?" },
                    { key: "ConnectdToWaterSupply", label: "Connected to a water supply with hot and cold water for drinking and cleaning?" },
                    { key: "ContainBathrm", label: "Bathroom facilities with privacy?" },
                    { key: "TenantAgreesUtilities", label: "Tenant agrees with the above?" },
                    { key: "AdditionalUtilitiesTerms", label: "If no, specify which items:" }
                ]
            },

            {
                key: "smokeAlarms", label: "Smoke Alarms", questions: [
                    { key: "SmokeAlarmInstalled", label: "Smoke alarms installed as per legislation?" },
                    { key: "SmokeAlarmWorking", label: "All smoke alarms in working order?" },
                    { key: "SmokeAlaramLastChecked", label: "Date last checked", type: "date" },
                    { key: "SmokeAlarmBttryReplaced", label: "Removable batteries replaced within last 12 months?" },
                    { key: "BattryChangedDate", label: "Date batteries were last changed", type: "date" },
                    { key: "HaveRemovableBattry", label: "Removable lithium batteries replaced as per manufacturer?" },
                    { key: "RemovableBattryChangedDate", label: "Date batteries were last changed", type: "date" }
                ]
            },
            {
                key: "others", label: "Other Safety Issues", questions: [
                    { key: "VisibleSIgnDamage", label: "Visible signs of damaged appliances?" },
                    { key: "VisibleElectricityHazard", label: "Visible electricity hazards?" },
                    { key: "VisibleGasHazard", label: "Visible gas hazards?" },
                    { key: "TenantAgreeSafetyIssues", label: "Tenant agrees with above?" },
                    { key: "AdditionalTermSafetyIssues", label: "If no, specify which items:" }
                ]
            },
            {
                key: "communication", label: "Communication Facilities", questions: [
                    { key: "TelephoneConnectd", label: "Telephone line connected?" },
                    { key: "InternetConnected", label: "Internet line connected?" }
                ]
            },
            {
                key: "waterEfficiency", label: "Water Efficiency Device", questions: [
                    { key: "SeperatedMetered", label: "Residential premises separately metered?" },
                    { key: "ShowerheadMaximumFlow", label: "Showerheads with max flow rate 9 L/min?" },
                    { key: "DualFlushToilet", label: "Dual flush toilets with minimum 3-star rating?" },
                    { key: "ColdWatrTapsMaximumFlow", label: "Cold water taps with max flow rate 9 L/min?" },
                    { key: "CheckedWaterLeakage", label: "Taps/toilets checked and fixed for leaks?" },
                    { key: "WaterEfficiencyDateChecked", label: "Date checked", type: "date" },
                    { key: "WatermeterReadingStart", label: "Water meter reading at START" },
                    { key: "DateofWaterMeterReadingStart", label: "Date of reading START", type: "date" },
                    { key: "WatermeterReadingEnd", label: "Water meter reading at END" },
                    { key: "DateOdWaterMeterReadingEnd", label: "Date of reading END", type: "date" }
                ]
            },
            {
                key: "additionalComments", label: "Additional Comments", questions: [
                    { key: "AdditionalComments", label: "General additional comments" }
                ]
            },
            {
                key: "approximateDates", label: "Approximate dates when work last done", questions: [
                    { key: "LastDateInstalledSmokeAlarms", label: "Installation/maintenance of smoke alarms", type: "date" },
                    { key: "LastDatePaintingExternal", label: "Painting of premises (external)", type: "date" },
                    { key: "LastDatePaintingInternal", label: "Painting of premises (internal)", type: "date" },
                    { key: "LastDateFloorCleaned", label: "Floor cleaned/replaced", type: "date" }
                ]
            },
            {
                key: "landlordWork", label: "Landlord's promise to undertake work", questions: [
                    { key: "LandlordAgreeToUndrtakeWork", label: "Work agreed to be undertaken by landlord" },
                    { key: "LandLordWorkDoneBy", label: "Date to complete work by", type: "date" },
                    { key: "LandLordWorkDoneNote", label: "Landlord work notes" }
                ]
            }
        ],
    };

    const togglePanel = (key) => {
        setOpenPanels((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const renderRadioGroup = (fieldKey, label) => (
        <div key={fieldKey} className="pl-2 d-flex align-items-center mb-3">
            <div className="radioNames">{label}</div>
            <Radio.Group
                value={switchValues[fieldKey]}
                onChange={(e) =>
                    setSwitchValues((prev) => ({
                        ...prev,
                        [fieldKey]: e.target.value,
                    }))
                }
                disabled={(utype === "13" || getDetails?.status === 1) ? true : false}
            >
                <Radio style={{ fontWeight: "500" }} value={true}>Yes</Radio>
                <Radio style={{ fontWeight: "500" }} value={false}>No</Radio>
            </Radio.Group>
        </div>
    );


    const viewinspectionmasterdata = (inspectionId,templateID) => {
        const data = { id: inspectionId };
        const baseUrl = geteditinspectiontemplate;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data, null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    const data = response.object;
                    setGetDetailsTemplate(data);
                    setSwitchValues({
                        PremisesStrctlySound: data.inspectionComplianceUtilitiesDetails.premisesStrctlySound,
                        LightingInRoom: data.inspectionComplianceUtilitiesDetails.lightingInRoom,
                        Ventilation: data.inspectionComplianceUtilitiesDetails.ventilation,
                        ElctrcityOutletsSockt: data.inspectionComplianceUtilitiesDetails.elctrcityOutletsSockt,
                        PlumbingandDrainage: data.inspectionComplianceUtilitiesDetails.plumbingandDrainage,
                        SuppliedElectricty: data.inspectionComplianceUtilitiesDetails.suppliedElectricty,
                        SuppliedGas: data.inspectionComplianceUtilitiesDetails.suppliedGas,
                        ConnectdToWaterSupply: data.inspectionComplianceUtilitiesDetails.connectdToWaterSupply,
                        ContainBathrm: data.inspectionComplianceUtilitiesDetails.containBathrm,
                        TenantAgreesUtilities: data.inspectionComplianceUtilitiesDetails.tenantAgreesUtilities,
                        AdditionalUtilitiesTerms: data.inspectionComplianceUtilitiesDetails.additionalUtilitiesTerms,

                        SignsMuds: data.inspectionComplianceUtilitiesDetails.signsMuds,
                        PestsVermin: data.inspectionComplianceUtilitiesDetails.pestsVermin,
                        Rubbish: data.inspectionComplianceUtilitiesDetails.rubbish,
                        ListedLooseFill: data.inspectionComplianceUtilitiesDetails.listedLooseFill,

                        SmokeAlarmInstalled: data.inspectionComplianceUtilitiesDetails.smokeAlarmInstalled,
                        SmokeAlarmWorking: data.inspectionComplianceUtilitiesDetails.smokeAlarmWorking,
                        SmokeAlaramLastChecked: data.inspectionComplianceUtilitiesDetails.smokeAlaramLastChecked,
                        SmokeAlarmBttryReplaced: data.inspectionComplianceUtilitiesDetails.smokeAlarmBttryReplaced,
                        BattryChangedDate: data.inspectionComplianceUtilitiesDetails.battryChangedDate,
                        HaveRemovableBattry: data.inspectionComplianceUtilitiesDetails.haveRemovableBattry,
                        RemovableBattryChangedDate: data.inspectionComplianceUtilitiesDetails.removableBattryChangedDate,

                        VisibleSIgnDamage: data.inspectionComplianceUtilitiesDetails.visibleSIgnDamage,
                        VisibleElectricityHazard: data.inspectionComplianceUtilitiesDetails.visibleElectricityHazard,
                        VisibleGasHazard: data.inspectionComplianceUtilitiesDetails.visibleGasHazard,
                        TenantAgreeSafetyIssues: data.inspectionComplianceUtilitiesDetails.tenantAgreeSafetyIssues,
                        AdditionalTermSafetyIssues: data.inspectionComplianceUtilitiesDetails.additionalTermSafetyIssues,

                        TelephoneConnectd: data.inspectionComplianceUtilitiesDetails.telephoneConnectd,
                        InternetConnected: data.inspectionComplianceUtilitiesDetails.internetConnected,

                        SeperatedMetered: data.inspectionComplianceUtilitiesDetails.seperatedMetered,
                        ShowerheadMaximumFlow: data.inspectionComplianceUtilitiesDetails.showerheadMaximumFlow,
                        DualFlushToilet: data.inspectionComplianceUtilitiesDetails.dualFlushToilet,
                        ColdWatrTapsMaximumFlow: data.inspectionComplianceUtilitiesDetails.coldWatrTapsMaximumFlow,
                        CheckedWaterLeakage: data.inspectionComplianceUtilitiesDetails.checkedWaterLeakage,

                        WaterEfficiencyDateChecked: data.inspectionComplianceUtilitiesDetails.waterEfficiencyDateChecked,
                        WatermeterReadingStart: data.inspectionComplianceUtilitiesDetails.watermeterReadingStart,
                        DateofWaterMeterReadingStart: data.inspectionComplianceUtilitiesDetails.dateofWaterMeterReadingStart,
                        WatermeterReadingEnd: data.inspectionComplianceUtilitiesDetails.watermeterReadingEnd,
                        DateOdWaterMeterReadingEnd: data.inspectionComplianceUtilitiesDetails.dateOdWaterMeterReadingEnd,

                        AdditionalComments: data.inspectionComplianceUtilitiesDetails.additionalComments,
                        LastDatePaintingExternal: data.inspectionComplianceUtilitiesDetails.lastDatePaintingExternal,
                        LastDatePaintingInternal: data.inspectionComplianceUtilitiesDetails.lastDatePaintingInternal,
                        LastDateInstalledSmokeAlarms: data.inspectionComplianceUtilitiesDetails.lastDateInstalledSmokeAlarms,
                        LastDateFloorCleaned: data.inspectionComplianceUtilitiesDetails.lastDateFloorCleaned,

                        LandlordAgreeToUndrtakeWork: data.inspectionComplianceUtilitiesDetails.landlordAgreeToUndrtakeWork,
                        LandLordWorkDoneBy: data.inspectionComplianceUtilitiesDetails.landLordWorkDoneBy,
                        TenantReceivedOn: data?.inspectionComplianceUtilitiesDetails?.tenantReceivedOn ? moment(data.inspectionComplianceUtilitiesDetails.tenantReceivedOn).format("YYYY-MM-DD") : ""
                    });

                    const doneBy = data.inspectionComplianceUtilitiesDetails.landLordWorkDoneBy || [];
                    const workNotes = data.inspectionComplianceUtilitiesDetails.landLordWorkDoneNote || [];
                    const mergedLandlordWorks = [];

                    const maxLength = Math.max(doneBy.length, workNotes.length);

                    for (let i = 0; i < maxLength; i++) {
                        mergedLandlordWorks.push({
                            date: doneBy[i] || '',
                            note: workNotes[i] || '',
                        });
                    }

                    setLandlordWorks(mergedLandlordWorks.length > 0 ? mergedLandlordWorks : [{ note: '', date: '' }]);


                    const dynamicSections = data.templates.map((template, index) => ({
                        label: template.label,
                        value: index + 3, // starting from 3 after the two static items
                        templateId: template.id,
                        attribute: template.attribute
                    }));

                    setInspectionSections(prev => {
                        const staticSections = prev.filter(section =>
                            section.value === 1 || (InspectionType === "Entry" && section.value === 2 || InspectionType === "Exit" && section.value === 2)
                        );
                        return [...staticSections, ...dynamicSections];
                    });

                    const disagreeMap = {};
                    data.templates.forEach((template, tIdx) => {
                        const disagreedFacilities = template.templatesDetails
                            .map((facility, fIdx) => facility.isTenantAgree === false ? fIdx : null)
                            .filter(index => index !== null);

                        if (disagreedFacilities.length) {
                            disagreeMap[tIdx] = disagreedFacilities;
                        }
                    });
                    setDisagreeIndexes(disagreeMap);
                    const matchedTemplateObject = getDetailsTemplate?.templates?.find(
                        (template) => template.id === templateID
                    );
                    if(matchedTemplateObject){
                        setComments(matchedTemplateObject.templateNotes || "")
                    }

                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })

    };


    const select = (event) => {
        inputRef.current.click();
    };

    const handleFileChange = async (e, templateIndex, facilityIndex = null) => {
        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];
            await handleUpload(file, templateIndex, facilityIndex);
        }
    };

    const handleUpload = async (file, templateIndex, facilityIndex) => {
        await uploadToS3WithSpinner(showSpinner, hideSpinner, "inspection/", "inspection", file, null, false).then((returnData) => {
            if (returnData.status === ActionStatus.Successfull) {
                const fileName = returnData.Key.split("/").pop();
                const imageObj = {
                    id: 0, // new image
                    src: FilePath + returnData.Key,
                    width: 1,
                    height: 1,
                    fileName: returnData.Key,
                    photoNumber: null
                };

                if (templateIndex === null || facilityIndex === null) {
                    setOverviewImages((prev) => [...prev, imageObj]);
                } else {
                    setGetDetailsTemplate((prevTemplates) => {
                        const updated = { ...prevTemplates };
                        const template = updated.templates[templateIndex];
                        if (template?.templatesDetails?.[facilityIndex]) {
                            const facility = template.templatesDetails[facilityIndex];
                            facility.templateDetailsPictures = [...(facility.templateDetailsPictures || []), imageObj];
                            facility.templateDetailsPictures = facility.templateDetailsPictures || [];
                        }
                        return updated;
                    });
                }
            }
        });
    };


    const renderRadioRow = (label, key, facility, tIdx, fIdx, disabled) => (
        <div className="d-flex align-items-center mb-2">
            <div style={{ width: 120, fontFamily: 'Inter', color: 'gray' }}>{label}</div>
            <Radio.Group
                value={facility[key] ?? null}
                onChange={(e) => handleFacilityChange(tIdx, fIdx, key, e.target.value)}
                options={[
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                ]}
                style={{ marginLeft: 10 }}
                disabled={disabled}
            />
        </div>
    );

    const extractSelectedAttributeList = () => {
        const activeSection = inspectionSections.find(section => section.value === purpose);
        const activeTemplate = getDetailsTemplate.templates?.find(template => template.id === activeSection?.templateId);
        if (!activeTemplate) return [];

        return activeTemplate.templatesDetails.map(facility => ({
            Id: facility.id,
            Cleaned: facility.cleaned,
            Undermanaged: facility.undermanaged,
            Working: facility.working,
            AgentComment: facility.agentComment,
            TenantComment: facility.tenantComment,
            IsTenantAgree: facility.isTenantAgree,
            CleanedByTenant: facility.cleanedByTenant,
            WorkingByTenant: facility.workingByTenant,
            UndermanagedByTenant: facility.undermanagedByTenant,
            AddUpdatePictures: [
                ...(facility.templateDetailsPictures || []).map(img => ({
                    Id: img.id,
                    PicturePath: img.fileName || ""
                })),
                ...(facility.images || []).map(img => ({
                    Id: 0,
                    PicturePath: img.fileName
                }))
            ]
        }));
    };


    const handleFinalSubmit = (navigate, onSuccess, autoSubmit,templateID) => {
        const activeSection = inspectionSections.find(section => section.value === purpose);
        const activeTemplate = getDetailsTemplate.templates.find(template => template.id === activeSection?.templateId);
        const activeTemplateId = activeTemplate?.id;

        const finalData = {
            InspectionId: getDetails.inspectionId,
            TemplateId: activeTemplateId,
            SelectedAttributeList: extractSelectedAttributeList(),
            TemplateNotes: comments,
            AddUpdatePictures: overviewImages?.map(img => ({
                Id: 0,
                PicturePath: img.fileName
            }))
        };

        if (InspectionType === "Routine") {
            delete finalData.SelectedAttributeList;
        }

        if (InspectionType === "Entry" && utype === "13") {
            finalData.IsTenantLogged = true;
        }
        if (autoSubmit) {
            finalData.IsAutoSubmitted = true;
        }

        makeRequestWithSpinner(showSpinner, hideSpinner, submittemplatedetails, "post", finalData, null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    //ToastRef.current.notify(["success", returnData.message]);
                    viewinspectionmasterdata(getDetails.inspectionId,templateID);

                    const container = document.querySelector(".material-work-desk-new");
                    if (container) {
                        container.scrollTo({ top: 0, behavior: "smooth" });
                    }

                    // Navigate to next section only if explicitly requested
                    const currentIndex = inspectionSections.findIndex(s => s.value === purpose);
                    const nextSection = inspectionSections[currentIndex + 1];

                    if (navigate === "submit" && nextSection) {
                        setPurpose(nextSection.value);
                    }

                    // ✅ Trigger onSuccess callback (e.g., switching tab)
                    if (typeof onSuccess === "function") {
                        onSuccess();
                    }
                    if (purpose >= 3 ) {
                        setComments("");
                        setOverviewImages([]);
                    }
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };


    const handleFacilityChange = (templateIndex, facilityIndex, field, value) => {
        setGetDetailsTemplate((prev) => {
            const updatedTemplates = [...prev.templates];
            updatedTemplates[templateIndex].templatesDetails[facilityIndex][field] = value;
            return { ...prev, templates: updatedTemplates };
        });
    };

    const handleSubmitOverView = (onSuccess, autoSubmit) => {
        const finalData = {
            Id: getDetails?.inspectionId,
            ShareWithOwner: shareWithOwner,
            ShareWithTenant: shareWithTenant,
            RentReview: parseInt(formData.RentReview),
            WaterMeterReading: parseInt(formData.WaterMeterReading),
            GeneralNotes: formData.GeneralNotes,
            FollowupActions: formData.FollowupActions,
        };

        if (autoSubmit) {
            finalData.IsAutoSubmitted = true;
        }

        const url = updateinspection;

        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData, null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    //ToastRef.current.notify(["success", returnData.message]);

                    if (typeof onSuccess === "function") {
                        onSuccess(); // ⬅️ switch tab or perform next action
                    } else {
                        // Default navigation logic if no callback is provided
                        viewinspectionmasterdata(getDetails.inspectionId);
                        if (InspectionType === "Entry" || InspectionType === "Exit"  ) {
                            setPurpose(2); // Compliance
                            const complianceSection = uniqueSections.find(s => s.value === 2);
                            if (complianceSection) setTabTemplateId(complianceSection.templateId);
                        } else if (InspectionType === "Routine") {
                            const firstDynamic = inspectionSections.find(s => s.value >= 3);
                            if (firstDynamic) setPurpose(firstDynamic.value);
                        }
                    }
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            });
    };



    const getSectionLabel = () => {
        const section = inspectionSections.find(sec => sec.value === purpose);
        return section ? section.label : "Overview";
    };

    const initialValues = {
        tenantFolioId: ""
    };


    const {
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
    } = useFormik({
        initialValues: initialValues,
        validationSchema: inspectionOverSchema,
        onSubmit: (values, action) => {
            handleSubmitMainOverView();
        },
    });

    const handleSubmitMainOverView = () => {
            const finalData = {
                Id: getDetails?.inspectionId,
                Summary: summary,
                AssignedAgent: propertyManager,
                TenantFolioId: tenantFolioId === "" ? null : tenantFolioId,
                Label: labelData.join(',') || ""
            };

            const url = updateoverviewinspection;
            makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData, null, false)
                .then((returnData) => {
                    if (returnData.status === ActionStatus.Successfull) {
                        ToastRef.current.notify(["success", returnData.message]);
                        setActiveTab("Edit Report")
                    } else {
                        ToastRef.current.notify(["error", returnData.message]);
                    }
                });
    };

    const handleDisagree = (value, templateIndex, facilityIndex) => {
        setDisagreeIndexes((prev) => {
            const updated = { ...prev };
            if (value === true) {
                if (updated[templateIndex]) {
                    updated[templateIndex] = updated[templateIndex].filter(index => index !== facilityIndex);
                    if (updated[templateIndex].length === 0) delete updated[templateIndex];
                }
            } else {
                updated[templateIndex] = [...(updated[templateIndex] || []), facilityIndex];

                // Get the selected facility
                const facility = getDetailsTemplate.templates[templateIndex].templatesDetails[facilityIndex];

                // Pre-fill modal state
                setModalFacilityData({ templateIndex, facilityIndex });
                setTenantModalComment(facility.tenantComment || "");
                setTenantModalImages(facility.images?.map(img => ({
                    id: img.id,
                    src: img.src || FilePath + img.fileName,
                    fileName: img.fileName
                })) || []);
                setPreviousDisagreeState({ templateIndex, facilityIndex });

                setOpenTenantModal(true);
            }
            return updated;
        });

        // Update isTenantAgree state
        setGetDetailsTemplate(prev => {
        const updatedTemplates = [...prev.templates];
        const facility = updatedTemplates[templateIndex].templatesDetails[facilityIndex];

        facility.isTenantAgree = value;

        if (value === true) {
            facility.cleanedByTenant = true;
            facility.undermanagedByTenant = true;
            facility.workingByTenant = true;
        }

        return { ...prev, templates: updatedTemplates };
    });
    };

  const handleTenantModalCancel = () => {
    debugger
  if (previousDisagreeState) {
    const { templateIndex, facilityIndex } = previousDisagreeState;

    // 1. Remove the disagree index
    setDisagreeIndexes((prev) => {
      const updated = { ...prev };
      if (updated[templateIndex]) {
        updated[templateIndex] = updated[templateIndex].filter(i => i !== facilityIndex);
        if (updated[templateIndex].length === 0) delete updated[templateIndex];
      }
      return updated;
    });

    // 2. Reset tenant flags for that facility
    setGetDetailsTemplate(prev => {
      const updatedTemplates = [...prev.templates];
      const facility = updatedTemplates[templateIndex].templatesDetails[facilityIndex];

      facility.isTenantAgree = null; // Clear agreement state
      facility.cleanedByTenant = null;
      facility.undermanagedByTenant = null;
      facility.workingByTenant = null;

      return { ...prev, templates: updatedTemplates };
    });

    // 3. Reset local UI state
    setPreviousDisagreeState(null);
  }

  // 4. Close modal
  setOpenTenantModal(false);
};



    const handleTenantModalUpload = async (e) => {
        for (let file of e.target.files) {
            await uploadToS3WithSpinner(showSpinner, hideSpinner, "inspection/", "inspection", file).then((res) => {
                if (res.status === ActionStatus.Successfull) {
                    setTenantModalImages((prev) => [
                        ...prev,
                        {
                            id: 0,
                            src: FilePath + res.Key,
                            fileName: res.Key,
                        },
                    ]);
                }
            });
        }
    };

    const handleTenantModalSubmit = () => {
        if (!tenantModalComment.trim()) {
            ToastRef.current.notify(["error", "Tenant comment is required."]);
            return;
        }

        if (!tenantModalImages || tenantModalImages.length === 0) {
            ToastRef.current.notify(["error", "At least one image must be uploaded."]);
            return;
        }

        // Proceed with your existing logic
        // e.g. update facility state with tenant comment and images
        const { templateIndex, facilityIndex } = modalFacilityData;
        const facility = getDetailsTemplate.templates[templateIndex].templatesDetails[facilityIndex];

        facility.tenantComment = tenantModalComment;
        facility.templateDetailsPictures = [
            ...(facility.templateDetailsPictures || []),
            ...tenantModalImages.map((img, idx) => ({
                id: img.id || 0,
                src: img.src,
                fileName: img.fileName,
                isTenantUploaded: true,
                photoNumber: img.photoNumber || idx + 1
            }))
        ];

        setGetDetailsTemplate((prev) => {
            const updatedTemplates = [...prev.templates];
            updatedTemplates[templateIndex].templatesDetails[facilityIndex] = facility;
            return { ...prev, templates: updatedTemplates };
        });

        setTenantModalImages([]);
        setTenantModalComment("");
        setOpenTenantModal(false);
        ToastRef.current.notify(["success", "Tenant comment saved successfully."]);
    };


    const handleAddTemplate = () => {
        if (!newTemplate.Attribute || !newTemplate.AttributeLabel) return;

        setTemplates([
            ...templates,
            { TemplateId: 0, ...newTemplate }
        ]);

        setNewTemplate({ Attribute: "", AttributeLabel: "" }); // Clear inputs
    };



    const openAddTemplateModal = () => {
        setOpenAddTemplate(true);
        setTemplates((prevTemplates) => [
            ...prevTemplates,
            {
                TemplateId: 0,
                Attribute: "",
                AttributeLabel: ""
            }
        ]);

        viewinspectiondata(getDetails.inspectionId);
    };


    const closeAddTemplate = () => {
        setOpenAddTemplate(false)
    }

    const viewinspectiondata = (InspectionUniqueId) => {
        const baseUrl = getaddedittemplatedetails + '?InspectionId=' + InspectionUniqueId;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get", null, null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    const data = response.object;
                    const transformedTemplates = data.templates.map((template) => {
                        return {
                            TemplateId: template.id,
                            Attribute: template.attribute,
                            AttributeLabel: template.label,
                        };
                    });
                    setTemplates(transformedTemplates);
                    const transformedAttributes = data.attributes.map(attribute => ({
                        value: attribute,
                        label: attribute
                    }));
                    setTemplateOptions(transformedAttributes)
                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })

    };

    const handleFieldChange = (index, field, value) => {
        const updatedTemplates = [...templates];
        updatedTemplates[index][field] = value;

        if (field === "Attribute") {
            updatedTemplates[index]["AttributeLabel"] = ""; // Clear label if needed
            updatedTemplates[index]["Attribute"] = value;
        }

        setTemplates(updatedTemplates);
    };


    const handleRemoveTemplate = (id) => {
        const finalData = {
            TemplateId: id,
            InspectionId: getDetails.inspectionId,
        };

        const url = removetemplatefrominspection;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData, null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                    viewinspectiondata(getDetails.inspectionId)
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            });
    };

    const handleAddTemplates = () => {
        // Only add newTemplate if it's filled
        const formattedNewTemplate =
            [{
                TemplateId: 0,
                Attribute: newTemplate.Attribute,
                AttributeLabel: newTemplate.AttributeLabel
            }];

        const finalData = {
            InspectionId: getDetails.inspectionId,
            Templates: [...templates, ...formattedNewTemplate]
        };

        const url = submitupdatedtemplatedetails;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData, null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                    viewinspectionmasterdata(getDetails.inspectionId);
                    closeAddTemplate(false);
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            });
    };


    const handleOpenFacility = (id) => {
        setOpenAddFacilities(true);
        setSelectedTemplateId(id);

    };

    const closeInspetionFacilities = () => {
        setOpenAddFacilities(false);
    };

    const handleFacilityChangeModule = (index, event) => {
        const newFacilities = facilities.map((facility, i) => {
            if (i === index) {
                return { ...facility, name: event.target.value };
            }
            return facility;
        });
        setFacilities(newFacilities);
    };

    const handleAddFacility = () => {
        setFacilities([...facilities, { id: facilities.length + 1, name: "" }]);
    };

    const handleSubmitFacilities = (onSuccess) => {
        const facilityNames = facilities.length > 0 ? facilities.filter(facility => facility.name).map(facility => facility.name):[];
        setFacilities([{ id: 1, name: "" }]);
        closeInspetionFacilities();
        handleFinalSubmitFacilities(facilityNames, onSuccess); // Send data to the API in the required format
    };

    const handleFinalSubmitFacilities = (facilityNames, onSuccess) => {
        const payload = facilityNames.map(name => ({
            TemplateId: tabTemplateId,
            Facility: name
        }));
        const url = addnewfacilitytotemplate;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", payload[0],null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                    setOpenAddFacilities(false);
                    viewinspectionmasterdata(getDetails.inspectionId);

                    if (typeof onSuccess === "function") {
                        onSuccess(); // ✅ Call follow-up action
                    }
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            })
            .catch((error) => {
                ToastRef.current.notify(["error", error.message]);
            });
    };

    const uniqueSections = inspectionSections.filter(
        (section, index, self) =>
            index === self.findIndex((s) => s.label === section.label)
    );

    const handleOpenFacilityWithSave = () => {
        handleFinalSubmit("save", () => {
            setOpenAddFacilities(true);
        },true);
        viewinspectionfacilitrydata()
    };

    const openAddTemplateModalWithSave = () => {
        handleFinalSubmit("save", () => {
            openAddTemplateModal(true); // your existing modal open logic
        },true);
    };

    let dragStartIndex = null;

    const handleDragStart = (index) => {
        dragStartIndex = index;
    };

    const handleDragOver = (e) => {
        e.preventDefault(); // Required to allow drop
    };

    const handleDrop = (dropIndex) => {
        const draggedItem = templates[dragStartIndex];
        const updatedList = [...templates];

        // Remove dragged item and insert at drop location
        updatedList.splice(dragStartIndex, 1);
        updatedList.splice(dropIndex, 0, draggedItem);

        setTemplates(updatedList);
    };

     const ShareWithOwner = (usertype) => {
        const baseUrl = emailroutinereporttoowner;
        let formData = {
            InspectionUniqueId: InspectionUniqueId,
            UserType:usertype,
            LoggedUserId: userId ? userId : uid
        }
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", formData, null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", response.message]);
                    PostApiWithSpinner(InspectionUniqueId);
                } else {
                    ToastRef.current.notify(["error", response.message]);
                }
            })
    };


    const finaliseMenu = (
        <Menu>
            <Menu.Item disabled={utype === "13"} key="assign" onClick={() => InspectionType === "Routine" ? ShareWithOwner(11) : SubmitFinalise("assign")}>
                {InspectionType === "Routine" ? "Share with Owner" : "Entry inspection assigned to tenant"}
            </Menu.Item>
            <Menu.Item key="return" onClick={() => InspectionType === "Routine" ? ShareWithOwner(13) : SubmitFinalise("return")}>
                {InspectionType === "Routine" ? "Share with Tenant" : "Entry inspection returned by tenant"}
            </Menu.Item>
        </Menu>
    );


   const handleComplete = (id) => {
    handleFinalSubmit("save");

    setTimeout(() => {
        const finalData = {
            InspectionUniqueId: InspectionUniqueId,
            Status: id,
            LoggedUserId: userId ? userId : uid
        };

        const url = updateinspectionstatus;

        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                    PostApiWithSpinner(InspectionUniqueId);
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            });
    }, 1500); // 3 seconds delay
};


    const closeIsTenantAccepted = () => {
        setIsTenantAccepted(false)
    }

    const handleTenantAccepted = (val) => {
        const finalData = {
            InspectionUniqueId: InspectionUniqueId,
            UserId: uid ? parseInt(uid) : userId,
            IsTenantAccepted: val
        };

        const url = reportacceptedbytenant;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData, null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                    PostApiWithSpinner(InspectionUniqueId)
                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            });
    };

    const handleDeleteFacility = (id, facilityId) => {
        const finalData = {
            TemplateId: id,
            FacilityId: facilityId,
        };

        const url = removetemplatefacilityfrominspection;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", finalData, null, false)
            .then((returnData) => {
                if (returnData.status === ActionStatus.Successfull) {
                    ToastRef.current.notify(["success", returnData.message]);
                    viewinspectionfacilitrydata();
                    PostApiWithSpinner(InspectionUniqueId);

                } else {
                    ToastRef.current.notify(["error", returnData.message]);
                }
            });

    };

    const viewinspectionfacilitrydata = () => {
        const activeSection = inspectionSections.find(section => section.value === purpose);
        const activeTemplate = getDetailsTemplate.templates.find(template => template.id === activeSection?.templateId);
        const activeTemplateId = activeTemplate?.id;

        const baseUrl = getaddupdatedacilitiestotemplate + '?TemplateId=' + activeTemplateId;
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setFacilityList(response.object);
                } else {
                    ToastRef(response.message);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const selectedLabel = inspectionSections?.find(s => s.value === purpose)?.label;

    let globalImageIndex = 0;

        const goback = () => {
            dynamicUrl(navigate, "ListInspection");
        }

  const handleFile = () => {
    const api = InspectionType === "Entry" ? generateentryexitinspectionreport : generateroutineinspectionreport;
    const baseUrl = `${api}?InspectionUniqueId=${InspectionUniqueId}`;

    showSpinner();

    fetch(baseUrl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    })
        .then(async (res) => {
            if (!res.ok) {
                throw new Error("Failed to generate inspection report");
            }

            // Extract filename from Content-Disposition header
            const disposition = res.headers.get("Content-Disposition");
            let fileName = "generateReport.pdf";
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match?.[1]) {
                    fileName = match[1];
                }
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            ToastRef.current.notify(["success", "Report downloaded successfully"]);
            getWithdrawalsList(1, 10);
        })
        .finally(() => {
            hideSpinner();
        });
};


    return (

        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"View Inspection"} goBack={utype === "13" ? false : goback} extraData={true} extraContent={
                        <div key="footer" style={{ display: "flex", justifyContent: "flex-end" }}>
                            {/* Render Finalise button if not finalized */}
                           {utype !== "13" && (<FilePdfOutlined onClick={handleFile} style={{fontSize:"24px" , marginRight:'10px', cursor:'pointer'}} /> )}
                            {getDetails?.status !== 1 && utype !== "13" && (
                                <button style={{ marginRight: "20px" }} className="pdb-save-changes mt-2" onClick={() => handleComplete(1)}>
                                    Complete
                                </button>)}
                            <div>
                            {utype !== "13" && (
                                <AntDropdown overlay={finaliseMenu} placement="bottomRight" arrow>
                                    <button style={{ marginRight: "20px" }} className="pdb-save-changes mt-2">
                                        {"Share"}<DownOutlined className="ml-1"/>
                                    </button>
                                </AntDropdown>)}
                                 {utype === "13" && getDetails.isTenantFinalised === null &&(
                                  <button style={{ marginRight: "20px" }} className="pdb-save-changes mt-2" onClick={() => SubmitFinalise("return")}>
                                    Complete
                                </button>)}
                            </div>


                            {/* Render Review Report button based on userRoleId and conditions */}
                            {getDetails.isAgentFinalised === true && (
                                <>
                                    {InspectionType === "Entry" && currentProfiles === 13 && getDetails.isTenantFinalised === null && (
                                        <div className="d-flex">
                                            <AntDropdown overlay={finaliseMenu} placement="bottomRight" arrow>
                                                <button style={{ marginRight: "20px" }} className="pdb-save-changes mt-2">
                                                    Share <DownOutlined />
                                                </button>
                                            </AntDropdown>
                                           
                                        </div>
                                    )}
                                </>
                            )}

                           
                        </div>

                    } />
                    <div style={{ display: "flex", padding: "5px", background: 'white', margin: '5px 15px', justifyContent: 'space-between' }}>
                        <div className="d-flex">
                            {tabs.map((tab) => (
                                <div
                                    key={tab}
                                    className={` button ${activeTab === tab ? "active-tab" : ""}`}
                                    onClick={() => handleTabs(tab)}
                                >
                                    {tab}
                                </div>
                            ))}
                        </div>
                        {activeTab === "Edit Report" && getDetails?.status !== 1 &&
                            !["Overview", "Compliance/Utilities"].includes(currentSectionLabel) && (
                                <div className="editLayout mr-4" onClick={openAddTemplateModalWithSave}>
                                    <BiEdit className="mr-1" /> Edit Layout
                                </div>
                            )}


                    </div>
                    <div className="material-work-desk-new bg-white m-3">
                        <ToastAlert ref={ToastRef} />
                        <div style={{ width: "100%" }}>
                            {getDetails?.isAgentFinalised === true && getDetails?.isCompleted === false && (
                                <div className="finalized">
                                    Finalized & Share to Tenant
                                </div>
                            )}
                            {getDetails?.status === 1 && utype !== "13" && (
                                <div className="finalized d-flex justify-content-between align-items-center">
                                    <div>
                                        Completed on {moment(getDetails?.completedDate).format("MM-DD-YYYY")}
                                    </div>
                                    <Button className="withdraw-btn" type="default" onClick={() => handleComplete(2)}>
                                        Re-open
                                    </Button>
                                </div>
                            )}
                            {activeTab === "Overview" ?
                                <div>
                                    <div className="mt-3">
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div className="detailsLabel ml-1">Inspection</div>
                                        </div>
                                        <div className="row m-1 detailsContainer">
                                            <TextBox
                                                label="Date"
                                                type="date"
                                                value={getDetails.inspectionDate ? getDetails.inspectionDate?.split("T")[0] : ""}
                                                readOnly
                                            />
                                            <TextBox
                                                label="Type"
                                                readOnly
                                                value={getDetails.sInspectionType || ""}
                                            />
                                            <div className="col-lg-6 col-sm-12">
                                                <label className="s1">Start Time</label>
                                                <TimePicker
                                                    value={getDetails.startTime ? moment(getDetails.startTime) : null}
                                                    format="hh:mm A"
                                                    minuteStep={15}
                                                    use12Hours
                                                    style={{ width: '100%', height: '40px' }}
                                                    disabled
                                                />
                                            </div>
                                            <TextBox
                                                label="Duration"
                                                readOnly
                                                value={
                                                    getDetails.startTime && getDetails.endTime
                                                        ? moment(getDetails.endTime).diff(moment(getDetails.startTime), 'minutes') + ' min'
                                                        : ''
                                                }
                                            />
                                            <div className="col-lg-6 col-sm-12">
                                                <label className="s1">End Time</label>
                                                <TimePicker
                                                    value={getDetails.endTime ? moment(getDetails.endTime) : null}
                                                    format="hh:mm A"
                                                    minuteStep={15}
                                                    use12Hours
                                                    style={{ width: '100%', height: '40px' }}
                                                    disabled
                                                />
                                            </div>
                                            <div className="cda-reportTo col-lg-6 col-sm-12">
                                                <label htmlFor="propertyManager" className="s1 w-100">Manager</label>
                                                <Dropdown
                                                    value={propertyManager}
                                                    onChange={(e) => setPropertymanager(e.value)}
                                                    options={dpdata}
                                                    optionLabel="text"
                                                    className="w-100 md:w-14rem"
                                                    placeholder="Select Manager"
                                                    style={{
                                                        width: "100%",
                                                        height: "40px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                    disabled={(utype === "13" || getDetails?.status === 1) ? true : false}

                                                />
                                            </div>
                                            <div className="col-lg-6 col-sm-12">
                                                <label className="s1">Labels</label>
                                                <Select
                                                    mode="tags"
                                                    style={{ width: "100%", height: "40px" }}
                                                    placeholder="Type and press Enter"
                                                    value={labelData || []}
                                                    onChange={(newValue) => setLabelData(newValue)}
                                                    tokenSeparators={[","]}
                                                    disabled={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                />
                                            </div>
                                            <TextBox
                                                label="Summary"
                                                value={summary}
                                                onChange={(e) => setSummary(e.target.value)}
                                                readOnly={(utype === "13" || getDetails?.status === 1) ? true : false}
                                            />

                                            <SelectInput readOnly={(utype === "13" || getDetails?.status === 1) ? true : false} label="Tenant" options={tenantOption} name="tenantFolioId" value={tenantFolioId} onChange={(val) => setTenantFolioId(val.value)} onBlur={handleBlur} error={errors.tenantFolioId} touched={touched.tenantFolioId} />
                                        </div>
                                        <div className="property-details-buttons">
                                            <Button className="pdb-save-changes" type="button" onClick={handleSubmitMainOverView}>
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                </div> : activeTab === "Edit Report" ||  (activeTab === "Report" && getDetails.isTenantFinalised === null) ?
                                    <div>
                                        <div className="section-tabs-wrapper">
                                            <div className="section-tabs-scroll">
                                                {uniqueSections.map((section) => {
                                                    let isSubmitted = false;

                                                    if (section.label === "Overview") {
                                                        isSubmitted = getDetailsTemplate?.inspectionDetails?.isSubmited;
                                                    } else if (section.label === "Compliance/Utilities") {
                                                        isSubmitted = getDetailsTemplate?.inspectionComplianceUtilitiesDetails?.isSubmited;
                                                    } else {
                                                        const matchedTemplate = getDetailsTemplate?.templates?.find(
                                                            (temp) => temp.label === section.label
                                                        );
                                                        isSubmitted = matchedTemplate?.isSubmited;
                                                    }

                                                    return (
                                                        <span
                                                            key={section.value}
                                                            className={`stat-items ${purpose === section.value ? 'active' : ''} ${isSubmitted ? 'submitted' : ''}`}
                                                            onClick={() => {
                                                                handleStatClick(section.value, section.templateId);
                                                                setCurrentSectionLabel(section.label);
                                                            }}
                                                        >
                                                            {section.label}
                                                        </span>
                                                    );
                                                })}
                                            </div>



                                        </div>
                                        {purpose === 1 ?
                                            <div>
                                                {/* <TextBox readOnly={(utype === "13" || getDetails?.status === 1) ? true : false} value={formData.RentReview} name="RentReview" label="Rent Review" onChange={handleInput} /> */}
                                                <TextBox readOnly={(utype === "13" || getDetails?.status === 1) ? true : false} value={formData.WaterMeterReading} name="WaterMeterReading" label="Water Meter Reading" onChange={handleInput} />
                                                <TextArea readOnly={(utype === "13" || getDetails?.status === 1) ? true : false} value={formData.GeneralNotes} name="GeneralNotes" label="General Notes" onChange={handleInput} />
                                                <TextArea readOnly={(utype === "13" || getDetails?.status === 1) ? true : false} value={formData.FollowupActions} name="FollowupActions" label="Followup Actions" onChange={handleInput} />
                                                 <div className="property-details-buttons mt-5">
                                                        <Button className="pdb-save-changes" type="button" onClick={handleSubmitOverView}>
                                                            {utype !== "13" ? "Submit" : "Next"}
                                                        </Button>
                                                    </div>
                                            </div>
                                            : purpose === 2 ?
                                                <div>
                                                    {collapsibleMap[purpose]?.map((section) => (
                                                        <div key={section.key}>
                                                            <div className="detailsCollapse p-3" onClick={() => togglePanel(section.key)}>
                                                                {openPanels[section.key] ? <IoIosArrowUp style={{ fontSize: "20px", cursor: 'pointer' }} /> : <IoIosArrowDown style={{ fontSize: "20px", cursor: 'pointer' }} />}{" "}
                                                                {section.label}
                                                            </div>

                                                            {openPanels[section.key] && (
                                                                <div className="px-4 py-2">
                                                                    {section.key === "propertyInfo" ? (
                                                                        <div className="row">
                                                                            <TextBox readOnly label="Agent Name" value={getDetailsTemplate?.inspectionPropertyInformation?.agentName || ""} />
                                                                            <TextBox readOnly label="Property Address" value={getDetailsTemplate?.inspectionPropertyInformation?.propertyAddress || ""} />
                                                                            <TextBox readOnly={(utype === "13" || getDetails?.status === 1) ? true : false} type="date" label="Tenant Received On" value={switchValues.TenantReceivedOn} onChange={(e) => setSwitchValues({ ...switchValues, TenantReceivedOn: e.target.value })} />
                                                                            <TextBox readOnly label="Tenants" value={getDetailsTemplate?.inspectionPropertyInformation?.tenants || ""} />
                                                                        </div>
                                                                    ) : section.questions.length > 0 ? (
                                                                        section.questions.map((q) => {
                                                                            if (q.type === "date") {
                                                                                if (q.key === "LandLordWorkDoneBy") {
                                                                                    // Prevent duplicate rendering – we'll render this with the notes field
                                                                                    return null;
                                                                                }
                                                                                return (
                                                                                    <div key={q.key} className="cda-reportTo col-lg-6 col-sm-12">
                                                                                        <label htmlFor={q.key} className="s1 w-100">{q.label}</label>
                                                                                        <DatePicker
                                                                                            value={switchValues[q.key] ? moment(switchValues[q.key], "DD-MM-YYYY") : null}
                                                                                            onChange={(date, dateString) =>
                                                                                                setSwitchValues((prev) => ({
                                                                                                    ...prev,
                                                                                                    [q.key]: dateString,
                                                                                                }))
                                                                                            }
                                                                                            format="DD-MM-YYYY"
                                                                                            disabledDate={(current) => current && current > moment().endOf('day')}
                                                                                            style={{ width: '50%', height: "40px" }}
                                                                                            disabled={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                                                        />
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            else if (q.key === "AdditionalComments") {
                                                                                return (
                                                                                    <TextArea
                                                                                        key={q.key}
                                                                                        label={q.label}
                                                                                        value={switchValues[q.key]}
                                                                                        onChange={(e) =>
                                                                                            setSwitchValues((prev) => ({
                                                                                                ...prev,
                                                                                                [q.key]: e.target.value,
                                                                                            }))
                                                                                        }
                                                                                        readOnly={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                                                    />
                                                                                );
                                                                            } else if (q.key === "LandLordWorkDoneNote") {
                                                                                return (
                                                                                    <div>
                                                                                        {landlordWorks.map((item, index) => (
                                                                                            <div key={index} className="d-flex align-items-end gap-2 mb-3">
                                                                                                <TextBox
                                                                                                    label="Landlord work notes"
                                                                                                    value={item.note}
                                                                                                    onChange={(e) => {
                                                                                                        const updated = [...landlordWorks];
                                                                                                        updated[index].note = e.target.value;
                                                                                                        setLandlordWorks(updated);
                                                                                                    }}
                                                                                                    readOnly={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                                                                />
                                                                                                <div className="cda-reportTo col-lg-3 col-sm-12 mb-2">
                                                                                                    <label className="s1 w-100">Date to complete work by</label>
                                                                                                    <DatePicker
                                                                                                        placeholder="Select date"
                                                                                                        value={item.date ? moment(item.date, "DD-MM-YYYY") : null}
                                                                                                        onChange={(date, dateString) => {
                                                                                                            const updated = [...landlordWorks];
                                                                                                            updated[index].date = dateString;
                                                                                                            setLandlordWorks(updated);
                                                                                                        }}
                                                                                                        format="DD-MM-YYYY"
                                                                                                        style={{ height: 40, width: '100%' }}
                                                                                                        disabledDate={(current) => current && current < moment().startOf('day')} disabled={(utype === "13" || getDetails?.status === 1) ? true : false} />
                                                                                                </div>
                                                                                                {index === landlordWorks.length - 1 && utype !== "13" && (
                                                                                                    <Button
                                                                                                        className="default"
                                                                                                        style={{ height: 40, marginBottom: '10px' }}
                                                                                                        onClick={() => setLandlordWorks([...landlordWorks, { note: '', date: '' }])}
                                                                                                    >
                                                                                                        + Add
                                                                                                    </Button>
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                );
                                                                            }


                                                                            else {
                                                                                return renderRadioGroup(q.key, q.label);
                                                                            }
                                                                        })

                                                                    ) : (
                                                                        <div className="text-muted">No specific questions in this section.</div>
                                                                    )}
                                                                </div>
                                                            )}


                                                        </div>
                                                    ))}
                                                    <div className="property-details-buttons mt-5">
                                                        <Button className="pdb-save-changes" type="button" onClick={SubmitGenerateReportEntery}>
                                                            {utype !== "13" ? "Submit" : "Next"}
                                                        </Button>
                                                    </div>

                                                </div> :
                                                <div>
                                                    <div className="pl-3 pr-3">
                                                        <Collapse
                                                            id={"overview"}
                                                            title={`${getSectionLabel()} Overview`}
                                                            data={
                                                                <div >
                                                                    {(() => {
                                                                        const template = getDetailsTemplate?.templates?.find(temp =>
                                                                            temp.label === inspectionSections.find(sec => sec.value === purpose)?.label
                                                                        );
                                                                        const agentNotes = comments || template?.templateNotes || "";
                                                                        const overviewImagesData = overviewImages.length > 0
                                                                            ? overviewImages
                                                                            : (template?.pictures || [])
                                                                                .filter(pic => pic.inspectionTemplateDetailsId === null)
                                                                                .map(pic => ({
                                                                                    id: pic.id,
                                                                                    src: pic.filePath || (FilePath + pic.fileName),
                                                                                    fileName: pic.fileName
                                                                                }));

                                                                        if (utype === "13") {
                                                                            return (
                                                                                <>
                                                                                    <div className="pl-3 mt-3 ml-4">
                                                                                        <div style={{ fontWeight: 600, marginBottom: "6px" }}>Agent Comments</div>
                                                                                        <div className="tenant-comment">{agentNotes || "No Comments"}</div>
                                                                                    </div>
                                                                                    {overviewImagesData.length > 0 && (
                                                                                        <div style={{ paddingLeft: "40px" }}>
                                                                                            <ImageGalleryModal
                                                                                                images={overviewImagesData.map(img => ({
                                                                                                    fileName: img.fileName,
                                                                                                    photoNumber: img.photoNumber // optional fallback handled inside modal
                                                                                                }))}
                                                                                                filePath={true}
                                                                                              startIndex={globalImageIndex}
                                                                                            />
                                                                                        </div>
                                                                                    )}


                                                                                </>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <>
                                                                                <div className="d-flex">
                                                                                    <div className="ml-4" style={{width:'47%'}}>

                                                                                        <TextArea
                                                                                            colVal={12}
                                                                                            customHeight={(utype === "13" || getDetails?.status === 1) ? "100%" : "125px"}                                                                                            label="Notes"
                                                                                            placeholder="Add Notes"
                                                                                            value={agentNotes}
                                                                                            onChange={(e) => setComments(e.target.value)}
                                                                                            className="facility-comment"
                                                                                            readOnly={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="mt-2">
                                                                                        <Button
                                                                                            type="default"
                                                                                            shape="circle"
                                                                                            icon={<CameraOutlined />}
                                                                                            onClick={() => setOpenOverviewImageModal(true)}
                                                                                            className="camera-icon-btn mt-4"
                                                                                            title="Upload Agent Image"
                                                                                            disabled={(getDetails?.status === 1) ? true : false}
                                                                                        />
                                                                                    </div>


                                                                                </div>
                                                                                <div style={{ marginLeft: "30px" }}>
                                                                                    <ImageGalleryModal
                                                                                        images={overviewImagesData.map(img => ({
                                                                                            fileName: img.fileName,
                                                                                            photoNumber: img.photoNumber // optional, fallback handled in the modal
                                                                                        }))}
                                                                                        filePath={true}
                                                                                        onRemoveImage={(indexToRemove) => {
                                                                                            const updated = [...overviewImages];
                                                                                            updated.splice(indexToRemove, 1);
                                                                                            setOverviewImages(updated);
                                                                                        }}
                                                                                        remove={true}
                                                                                        startIndex={globalImageIndex}
                                                                                    />
                                                                                </div>

                                                                            </>
                                                                        );
                                                                    })()}

                                                                    {InspectionType === "Routine" && (
                                                                        <div className="property-details-buttons">
                                                                            <Button className="pdb-save-changes" type="button" onClick={() => handleFinalSubmit("submit")}>
                                                                                Submit
                                                                            </Button>
                                                                        </div>)}
                                                                </div>
                                                            } />
                                                    </div>
                                                    {InspectionType !== "Routine" && (
                                                        <div className="pl-3 pr-3">
                                                            {getDetailsTemplate?.templates.map((template, tIdx) => {
                                                                if (template.label !== inspectionSections.find(s => s.value === purpose)?.label) return null;
                                                                return template.templatesDetails.map((facility, fIdx) => (
                                                                    <Collapse
                                                                        key={facility.id}
                                                                        id={facility.facilityName}
                                                                        title={facility.facilityName}
                                                                        agentIcon={
                                                                            getDetails?.status === 1 &&
                                                                                (facility.cleaned !== null && facility.undermanaged !== null && facility.working !== null) ? (
                                                                                <CheckCircleTwoTone
                                                                                    twoToneColor={
                                                                                        facility.cleaned && facility.undermanaged && facility.working ? '#52c41a' : '#faad14'
                                                                                    }
                                                                                />
                                                                            ) : null
                                                                        }

                                                                        tenantIcon={
                                                                            getDetails?.status === 1 &&
                                                                                (facility.cleanedByTenant !== null && facility.undermanagedByTenant !== null && facility.workingByTenant !== null) ? (
                                                                                <CheckCircleTwoTone
                                                                                    twoToneColor={
                                                                                        facility.cleanedByTenant && facility.undermanagedByTenant && facility.workingByTenant
                                                                                            ? '#52c41a'
                                                                                            : '#faad14'
                                                                                    }
                                                                                />
                                                                            ) : null
                                                                        }

                                                                        data={
                                                                            <div style={{ padding: "0px 30px" }}>

                                                                                <div className="row" style={{ width: "100%" }}>

                                                                                    {utype === "13" ? (
                                                                                        <>

                                                                                            <div className="d-flex">

                                                                                                <div className="pl-3 mt-3 ">
                                                                                                    <div style={{ fontWeight: 600, marginBottom: "6px" }}>{"Agent Comments"}</div>
                                                                                                    <div className="d-flex">
                                                                                                        <div className="tenant-comment">
                                                                                                            {facility.agentComment || "No Comments"}
                                                                                                        </div>

                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className="facility-radio-group ml-5 mt-5">
                                                                                                    {renderRadioRow("Clean", "cleaned", facility, tIdx, fIdx, (utype === "13" || getDetails?.status === 1) ? true : false)}
                                                                                                    {renderRadioRow("Undamaged", "undermanaged", facility, tIdx, fIdx, (utype === "13" || getDetails?.status === 1) ? true : false)}
                                                                                                    {renderRadioRow("Working", "working", facility, tIdx, fIdx, (utype === "13" || getDetails?.status === 1) ? true : false)}
                                                                                                </div>
                                                                                            </div>
                                                                                            {facility.templateDetailsPictures?.some(img => img.isTenantUploaded === false) && (
                                                                                                <div className="pl-3 ml-2">
                                                                                                    <ImageGalleryModal
                                                                                                        images={facility.templateDetailsPictures
                                                                                                            .filter(img => img.isTenantUploaded === false)
                                                                                                            .map(img => ({
                                                                                                                fileName: img.fileName,
                                                                                                                photoNumber: img.photoNumber, // fallback handled in modal
                                                                                                            }))}
                                                                                                        filePath={true}
                                                                                                       startIndex={globalImageIndex}
                                                                                                    />
                                                                                                </div>
                                                                                            )}


                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <div className="facility-section-container">
                                                                                                {/* Left: Comment + Camera + Images */}
                                                                                                <div className="facility-comment-upload">
                                                                                                    <div className="d-flex align-items-start">
                                                                                                        <TextArea
                                                                                                            customHeight={(utype === "13" || getDetails?.status === 1) ? "100%" : "125px"}
                                                                                                            label="Agent Comment"
                                                                                                            value={facility.agentComment || ""}
                                                                                                            onChange={(e) => handleFacilityChange(tIdx, fIdx, "agentComment", e.target.value)}
                                                                                                            className="facility-comment"
                                                                                                            readOnly={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                                                                        />
                                                                                                        <Button
                                                                                                            type="default"
                                                                                                            shape="circle"
                                                                                                            icon={<CameraOutlined />}
                                                                                                            onClick={() => {
                                                                                                                setAgentImageModalData({ templateIndex: tIdx, facilityIndex: fIdx });
                                                                                                                setOpenAgentImageModal(true);
                                                                                                            }}
                                                                                                            className="camera-icon-btn mt-4"
                                                                                                            title="Upload Agent Image"
                                                                                                            disabled={(getDetails?.status === 1) ? true : false}
                                                                                                        />
                                                                                                        {/* Right: Radio Buttons */}
                                                                                                        <div className="facility-radio-group ml-5 mt-5">
                                                                                                            {renderRadioRow("Clean", "cleaned", facility, tIdx, fIdx, (utype === "13" || getDetails?.status === 1) ? true : false)}
                                                                                                            {renderRadioRow("Undamaged", "undermanaged", facility, tIdx, fIdx, (utype === "13" || getDetails?.status === 1) ? true : false)}
                                                                                                            {renderRadioRow("Working", "working", facility, tIdx, fIdx, (utype === "13" || getDetails?.status === 1) ? true : false)}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {facility.templateDetailsPictures.length > 0 && (
                                                                                                        <div className="ml-2">
                                                                                                            <ImageGalleryModal
                                                                                                                images={facility.templateDetailsPictures
                                                                                                                    .filter(img => img.isTenantUploaded !== true)
                                                                                                                    .map(img => ({
                                                                                                                        fileName: img.fileName,
                                                                                                                        photoNumber: img.photoNumber
                                                                                                                    }))
                                                                                                                }
                                                                                                                photonumber={true}
                                                                                                                filePath={true}
                                                                                                                startIndex={globalImageIndex}
                                                                                                                onRemoveImage={(indexToRemove) => {
                                                                                                                    const filteredImages = facility.templateDetailsPictures.filter(img => img.isTenantUploaded !== true);
                                                                                                                    const imageToRemove = filteredImages[indexToRemove];

                                                                                                                    // Now update the entire facility state
                                                                                                                    const updatedImages = facility.templateDetailsPictures.filter(img => img.fileName !== imageToRemove.fileName);

                                                                                                                    // Update in template state
                                                                                                                    setGetDetailsTemplate((prevTemplates) => {
                                                                                                                        const updatedTemplates = [...prevTemplates.templates];
                                                                                                                        const template = updatedTemplates[tIdx]; // templateIndex from surrounding scope
                                                                                                                        template.templatesDetails[fIdx].templateDetailsPictures = updatedImages;
                                                                                                                        return { ...prevTemplates, templates: updatedTemplates };
                                                                                                                    });
                                                                                                                }}
                                                                                                                remove={utype !== "13" ? true : false}
                                                                                                            />
                                                                                                        </div>
                                                                                                    )}
                                                                                                    <div style={{float:'right'}}><DeleteOutlined style={{fontSize:'18px'}}  onClick={() => handleDeleteFacility(template.id,facility.facilityId)}/></div>


                                                                                                </div>


                                                                                            </div>


                                                                                        </>
                                                                                    )}

                                                                                </div>
                                                                                {currentProfiles === 13 || utype === "13" && (
                                                                                    <div className="pl-3 pr-4 mb-3 d-flex justify-content-end" style={{ gap: "10px" }}>
                                                                                        <Button type={facility.isTenantAgree === false ? "primary" : "default"} danger={facility.isTenantAgree === false} anger onClick={() => handleDisagree(false, tIdx, fIdx)}>Disagree</Button>
                                                                                        <Button type={facility.isTenantAgree === true ? "primary" : "default"} style={facility.isTenantAgree === true ? { backgroundColor: "#52c41a", borderColor: "#52c41a", color: "#fff" } : {}} onClick={() => handleDisagree(true, tIdx, fIdx)}>Agree</Button>
                                                                                    </div>
                                                                                )}

                                                                                {disagreeIndexes[tIdx]?.includes(fIdx) || facility.isTenantAgree === null ? (
                                                                                    <div className="mt-5">
                                                                                        {/* Tenant Comment Section */}
                                                                                        <div className="d-flex">
                                                                                            {facility.tenantComment && (
                                                                                                <div>
                                                                                                    <div style={{ fontWeight: 600, marginBottom: "6px", marginLeft: '18px' }}>Tenant Comment</div>
                                                                                                    <div className="ml-3 tenant-comment" style={{ marginBottom: "10px"}}>
                                                                                                        {facility.tenantComment}
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Tenant Radio Buttons (only for tenant role) */}
                                                                                            {((utype === "13" && facility.tenantComment) || (utype !== "13" && facility.tenantComment)) && (<div>
                                                                                                <div className="facility-radio-group ml-5 mt-3">
                                                                                                    {renderRadioRow("Clean", "cleanedByTenant", facility, tIdx, fIdx, true)}
                                                                                                    {renderRadioRow("Undamaged", "undermanagedByTenant", facility, tIdx, fIdx, true)}
                                                                                                    {renderRadioRow("Working", "workingByTenant", facility, tIdx, fIdx, true)}
                                                                                                </div>
                                                                                            </div>
                                                                                            )}
                                                                                        </div>
                                                                                        {/* Tenant Uploaded Images */}
                                                                                        {facility.templateDetailsPictures?.some(img => img.isTenantUploaded === true) && (
                                                                                            <div className="pl-3">
                                                                                                <div className=" mt-3">
                                                                                                    <ImageGalleryModal
                                                                                                        images={facility.templateDetailsPictures
                                                                                                            .filter(img => img.isTenantUploaded === true)
                                                                                                            .map(img => ({
                                                                                                                fileName: img.fileName,
                                                                                                                photoNumber: img.photoNumber
                                                                                                            }))
                                                                                                        }
                                                                                                        photonumber={true}
                                                                                                        filePath={true}
                                                                                                        onRemoveImage={(indexToRemove) => {
                                                                                                            const tenantImages = facility.templateDetailsPictures.filter(img => img.isTenantUploaded === true);
                                                                                                            const imageToRemove = tenantImages[indexToRemove];

                                                                                                            const updatedImages = facility.templateDetailsPictures.filter(
                                                                                                                img => img.fileName !== imageToRemove.fileName
                                                                                                            );

                                                                                                            setGetDetailsTemplate((prevTemplates) => {
                                                                                                                const updatedTemplates = [...prevTemplates.templates];
                                                                                                                const template = updatedTemplates[tIdx];
                                                                                                                template.templatesDetails[fIdx].templateDetailsPictures = updatedImages;
                                                                                                                return { ...prevTemplates, templates: updatedTemplates };
                                                                                                            });
                                                                                                        }}
                                                                                                        remove={(utype === "13" || getDetails?.status === 1) ? true : false}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                ) : null}



                                                                            </div>

                                                                        }
                                                                    />

                                                                ));
                                                            })}

                                                            {utype !== "13" && (
                                                                <div className="add-field-wrapper">
                                                                    <span className="add-field-link" onClick={handleOpenFacilityWithSave}>
                                                                        + Add Facility
                                                                    </span>
                                                                </div>
                                                            )}



                                                            <div className="property-details-buttons">
                                                                <Button className="pdb-save-changes" type="button" onClick={() => handleFinalSubmit("submit")}>
                                                                  {getDetailsTemplate?.templates[getDetailsTemplate.templates.length - 1]?.id === tabTemplateId ? "Submit": "Next"} 
                                                                </Button>
                                                            </div>
                                                        </div>)}
                                                </div>
                                        }
                                    </div> :<div>{utype !== "13" && (<CustomActivity ModuleType={6} RecordId={getDetails.inspectionId}/>)}</div>}
                                    {utype === "13" && getDetails.isTenantFinalised && (
                                        <div>
                                            <div className="tenantFinalised">
                                                <div className="tenantFinalisedTitle">Thank you for your review !</div>
                                            </div>
                                            <div className="d-flex justify-content-center mt-5" style={{color:"#155C75" , textDecoration:'underline', cursor:"pointer"}} onClick={handleFile} >
                                                Please click here to download the  file <span> <FilePdfOutlined style={{ fontSize: "24px", marginLeft: '10px', cursor: 'pointer' }} /></span>
                                               
                                            </div>
                                        </div>
                                    )}
                        </div>
                        <CustomModal
                            title="Add/Update Template"
                            width={800}
                            closable={closeAddTemplate}
                            visible={openAddTemplate}
                            onCancel={closeAddTemplate}
                            modalData={
                                <div style={{ marginLeft: "10px" }}>
                                    {/* 🔄 Existing Templates with Drag-and-Drop */}
                                    {templates.map((template, index) => (
                                        <div
                                            key={index}
                                            draggable
                                            onDragStart={() => handleDragStart(index)}
                                            onDragOver={handleDragOver}
                                            onDrop={() => handleDrop(index)}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "10px",
                                                border: "1px dashed #ccc",
                                                padding: "8px",
                                                borderRadius: "4px",
                                                backgroundColor: "#f9f9f9",
                                                cursor: "move"
                                            }}
                                        >
                                            <TextBox
                                                name={`attributeLabel-${index}`}
                                                placeholder="Enter Attribute Label"
                                                value={template.AttributeLabel}
                                                onChange={(e) => handleFieldChange(index, "AttributeLabel", e.target.value)}
                                            />
                                            {templates.length > 1 && (
                                                <MdDeleteOutline
                                                    className="ml-2 mt-1"
                                                    style={{ fontSize: '22px', cursor: "pointer" }}
                                                    onClick={() => handleRemoveTemplate(template.TemplateId)}
                                                />
                                            )}
                                        </div>
                                    ))}

                                    {/* ➕ New Template Entry */}
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                        <SelectInput
                                            label="Attribute"
                                            name="new-attribute"
                                            options={templateOptions}
                                            value={newTemplate.Attribute}
                                            onChange={(selectedOption) =>
                                                setNewTemplate(prev => ({ ...prev, Attribute: selectedOption.value }))
                                            }
                                            placeholder="Select Attribute"
                                            colVal={4}
                                            isMandatory={true}
                                        />
                                        <TextBox
                                            name="new-attribute-label"
                                            placeholder="Enter Attribute Label"
                                            value={newTemplate.AttributeLabel}
                                            onChange={(e) =>
                                                setNewTemplate(prev => ({ ...prev, AttributeLabel: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'end', marginRight: '20px' }}>
                                        <button className="addTemplate" onClick={handleAddTemplate}>
                                            Add Template
                                        </button>
                                    </div>
                                </div>
                            }
                            footer={[
                                <div key="footer" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button
                                        style={{ marginRight: "20px" }}
                                        className="pdb-save-changes mt-2"
                                        onClick={handleAddTemplates}
                                    >
                                        Submit
                                    </button>
                                </div>
                            ]}
                        />

                        <CustomModal
                            title="Tenant Comment"
                            visible={openTenantModal}
                            closable={handleTenantModalCancel}
                            width={600}
                            onCancel={handleTenantModalCancel}
                            modalData={
                                <div className="p-3">
                                    {(() => {
                                        const { templateIndex, facilityIndex } = modalFacilityData;
                                        const facility = getDetailsTemplate?.templates?.[templateIndex]?.templatesDetails?.[facilityIndex];

                                        if (!facility) return null;

                                        return (
                                            <>
                                                <div className="pl-3">
                                                    {renderRadioRow("Clean", "cleanedByTenant", facility, templateIndex, facilityIndex, false)}
                                                    {renderRadioRow("Undamaged", "undermanagedByTenant", facility, templateIndex, facilityIndex, false)}
                                                    {renderRadioRow("Working", "workingByTenant", facility, templateIndex, facilityIndex, false)}
                                                </div>
                                            </>
                                        );
                                    })()}

                                    <TextArea
                                        isMandatory
                                        colVal={12}
                                        label="Comment"
                                        value={tenantModalComment}
                                        onChange={(e) => setTenantModalComment(e.target.value)}
                                    />
                                    <div className="mr-4 ml-2">
                                        <FileUpload
                                            isMandatory
                                            label="Upload Image"
                                            inputRef={inputRef}
                                            onClickHandler={() => inputRef.current.click()}
                                            handleFileChange={(e) => handleTenantModalUpload(e)}
                                            images={tenantModalImages}
                                            setImages={setTenantModalImages}
                                        />
                                    </div>
                                </div>
                            }
                            footer={
                                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '10px' }}>
                                    <Button key="submit" className="button-default mr-1" onClick={handleTenantModalCancel}>
                                        Cancel
                                    </Button>
                                    <Button key="submit" className="pdb-save-changes" onClick={handleTenantModalSubmit}>
                                        Save
                                    </Button>
                                </div>
                            }

                        />

                        <CustomModal
                            title="Upload Agent Images"
                            visible={openAgentImageModal}
                            closable={() => setOpenAgentImageModal(false)}
                            onCancel={() => setOpenAgentImageModal(false)}
                            width={600}
                            modalData={
                                (() => {
                                    const { templateIndex: tIdx, facilityIndex: fIdx } = agentImageModalData || {};
                                    const facility = getDetailsTemplate?.templates?.[tIdx]?.templatesDetails?.[fIdx];

                                    if (!facility) return <div className="p-3 text-muted">No facility selected.</div>;

                                    const images = [
                                        ...(facility.templateDetailsPictures?.filter(img => img.isTenantUploaded !== true)
                                            .map(img => ({
                                                id: img.id,
                                                src: img.picturePath || (FilePath + img.fileName),
                                                fileName: img.fileName
                                            })) || []),
                                        ...(facility.images || [])
                                    ];

                                    return (
                                        <div style={{ marginTop: '-10px' }} className="col-lg-12">
                                            <FileUpload
                                                label="Upload Image"
                                                inputRef={(el) => (inputRefs.current[`${tIdx}-${fIdx}`] = el)}
                                                onClickHandler={() => inputRefs.current[`${tIdx}-${fIdx}`]?.click()}
                                                handleFileChange={(e) => handleFileChange(e, tIdx, fIdx)}
                                                images={images}
                                                setImages={(imgs) => {
                                                    setGetDetailsTemplate((prevTemplates) => {
                                                        const updatedTemplates = [...prevTemplates.templates];
                                                        const template = updatedTemplates[tIdx];
                                                        const facility = template.templatesDetails[fIdx];

                                                        const cleanedImages = imgs.filter(img => img.isTenantUploaded !== true);

                                                        facility.templateDetailsPictures = cleanedImages.map((img, i) => ({
                                                            id: img.id || 0,
                                                            src: img.src,
                                                            fileName: img.fileName,
                                                            photoNumber: img.photoNumber || i + 1,
                                                            isTenantUploaded: img.isTenantUploaded || false
                                                        }));

                                                        updatedTemplates[tIdx].templatesDetails[fIdx] = facility;

                                                        return {
                                                            ...prevTemplates,
                                                            templates: updatedTemplates
                                                        };
                                                    });
                                                }}

                                            />
                                        </div>
                                    );
                                })()
                            }
                            footer={
                                <div className="mt-2" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                    <Button className="mr-2" onClick={() => setOpenAgentImageModal(false)}>Cancel</Button>
                                    <Button
                                        type="primary"
                                        className="pdb-save-changes"
                                        onClick={() => setOpenAgentImageModal(false)}
                                    >
                                        Save
                                    </Button>
                                </div>
                            }
                        />
                        <CustomModal
                            title="Upload Overview Images"
                            visible={openOverviewImageModal}
                            closable={() => setOpenOverviewImageModal(false)}
                            onCancel={() => setOpenOverviewImageModal(false)}
                            width={600}
                            modalData={
                                <FileUpload
                                    readonly={utype === "13"}
                                    label="Upload Image"
                                    inputRef={inputRef}
                                    onClickHandler={select}
                                    handleFileChange={(e) => handleFileChange(e, null)}
                                    images={overviewImages}
                                    setImages={setOverviewImages}
                                />
                            }
                            footer={
                                <div className="mt-2" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button className="mr-2" onClick={() => setOpenOverviewImageModal(false)}>Cancel</Button>
                                    <Button
                                        className="pdb-save-changes"
                                        onClick={() => {
                                            setOpenOverviewImageModal(false);
                                            setOverviewImages(overviewImages); // ← push to main view state
                                        }}
                                    >
                                        Save
                                    </Button>
                                </div>
                            }
                        />

                        <CustomModal
                            title="Inspection Facilities"
                            width={600}
                            closable={closeInspetionFacilities}
                            visible={openAddFacilities}
                            onCancel={closeInspetionFacilities}
                            modalData={
                                <div
                                    className="row"
                                    style={{ marginTop: "30px"}}
                                >
                                    {facilityList?.facilities
                                        ?.filter(facility => facilityList.selectedFacilities?.includes(facility.id))
                                        ?.map((facility, index) => (
                                            <div
                                                key={facility.id}
                                                className="pr-3 col-12 d-flex justify-content-between align-items-center mb-2"
                                                style={{paddingLeft:'30px'}}
                                            >
                                                <span>{facility.facility}</span>
                                                <Button
                                                    type="text"
                                                    danger
                                                    icon={<i className="fa fa-trash" />}
                                                    onClick={() => handleDeleteFacility(facilityList.templateId, facility.id)}
                                                />
                                            </div>
                                        ))}


                                    {facilities.map((facility, index) => (
                                        <div key={facility.id} className="col-12">
                                            <TextBox
                                                colVal={12}
                                                // label={`Facility ${facility.id}`}
                                                placeholder={"Facility"}
                                                value={facility.name}
                                                onChange={(e) => handleFacilityChangeModule(index, e)}
                                            />
                                        </div>
                                    ))}
                                    <div style={{ display: 'flex', justifyContent: 'end', marginLeft: '-20px' }}>
                                        <button style={{ border: '1px solid #d0d5dd', height: '30px', borderRadius: '4px' }} className="mt-2" type="button" onClick={handleAddFacility}>
                                            Add Facility
                                        </button>
                                    </div>
                                </div>
                            }
                            footer={[
                                <div
                                    key="footer"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <button
                                        style={{ marginRight: "20px" }}
                                        className="pdb-save-changes mt-2"
                                        onClick={handleSubmitFacilities}
                                    >
                                        Submit
                                    </button>
                                </div>,
                            ]}
                        />

                        <CustomModal
                            title={"Accept Inspection Report"}
                            width={600}
                            //closable={closeIsTenantAccepted}
                            visible={isTenantAccepted}
                            //onCancel={closeIsTenantAccepted}
                            modalData={
                                <div className="row" style={{ marginTop: "10px", marginLeft: "2px" }}>
                                    <div className="finalized">{`${InspectionType} Report`}</div>
                                    <div className="mt-2" style={{ fontFamily: 'inter', color: 'gray' }}> {address}</div>
                                </div>
                            }
                            footer={[
                                <div key="footer">
                                    <button style={{ background: "#348fb2", color: "white", marginTop: '5px' }} onClick={() => handleTenantAccepted(true)} className="btn">
                                        Accept
                                    </button>
                                </div>,
                            ]}
                        />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewInspection;
